import type { Component, Entity2D } from '../../odie';

import { ChameleonBlockProps, ColorBlockOptionDef } from '../defs/block';
import {
  ChameleonBlockView,
  ChameleonColor,
} from '../views/blocks/ChameleonBlockView';

// types
//-----------------------------------------------------------------------------
export type ChameleonBlockComponentOptions = {
  props: ChameleonBlockProps;
  option?: number;
};

/*
    chameleon block component
*/
export class ChameleonBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockChameleon';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: ChameleonBlockView;

  private props!: ChameleonBlockProps;

  // properties
  //-------------------------------------------------------------------------
  public get activeColor(): ChameleonColor {
    return this.view.color;
  }

  public set activeColor(v: ChameleonColor) {
    this.view.color = v;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: ChameleonBlockComponentOptions): void {
    const option = options.option ?? 0;

    // get option def
    const optionDef = options.props.options?.[option] as ColorBlockOptionDef;

    this.props = options.props;

    // create chameleon block view
    this.view = new ChameleonBlockView(options.props);

    // set initial color
    this.activeColor = optionDef.color;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  // api
  //-------------------------------------------------------------------------
  public getGameplayState(): number {
    const options = this.props.options as ColorBlockOptionDef[];

    return options.findIndex((opt) => {
      return opt.color === this.activeColor;
    });
  }
}
